const initialState = {
  success: false,
  loading: false,
  error: null,
  taxCollectionsList: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  taxCollection: {
    data: null,
    loading: false,
    error: null,
  },
  PH10s: {
    data: null,
    loading: false,
    error: null,
  },
  yearlyTotalAndPaidTax: {
    data: [],
    loading: false,
    error: null,
  },
  yearlyPaidAndPendingUnits: {
    data: [],
    loading: false,
    error: null,
  },
  yearlyTotalAndPaidTaxOfZone: {
    data: [],
    loading: false,
    error: null,
  },
  yearlyPaidAndPendingUnitsOfZone: {
    data: [],
    loading: false,
    error: null,
  },
  yearlyPaidAndPendingUnitsOfCircle: {
    data: [],
    loading: false,
    error: null,
  },
  yearlyTotalAndPaidTaxOfCircle: {
    data: [],
    loading: false,
    error: null,
  },
  totalRegisteredPropertiesOfZone: {
    data: null,
    loading: false,
    error: null,
  },
  taxOfZone: {
    data: null,
    loading: false,
    error: null,
  },
  topPaidUnitsOfZone: {
    data: [],
    loading: false,
    error: null,
  },
  topDefaultUnitsOfZone: {
    data: [],
    loading: false,
    error: null,
  },
  totalRegisteredPropertiesOfCircle: {
    data: null,
    loading: false,
    error: null,
  },
  taxOfCircle: {
    data: null,
    loading: false,
    error: null,
  },
  topPaidUnitsOfCircle: {
    data: [],
    loading: false,
    error: null,
  },
  topDefaultUnitsOfCircle: {
    data: [],
    loading: false,
    error: null,
  },
  yearlyPaidTaxTi: {
    data: [],
    loading: false,
    error: null,
  },
  totalPendingTaxTi: {
    data: null,
    loading: false,
    error: null,
  },
  circleOrZoneName: {
    data: [],
    loading: false,
    error: null,
  },
  taxDetailsOfPropertyBasedOnYear: {
    data: [],
    loading: false,
    error: null,
  },
  generateChallan: {
    data: [],
    loading: false,
    error: null,
  },
  taxPropertiesList: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
};

const propertyReducer = (
  state = initialState,
  { obj, type, error, payload, data, pagination }
) => {
  switch (type) {
    case "RESET_TAX_COLLECTION":
      return initialState;

    case "GET_TAX_COLLECTIONS_LIST":
      return {
        ...state,
        type,
        error: null,
        taxCollectionsList: {
          ...initialState.taxCollectionsList,
          loading: true,
        },
      };

    case "GET_TAX_COLLECTIONS_LIST_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        taxCollectionsList: {
          ...state.taxCollectionsList,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_TAX_COLLECTIONS_LIST_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        taxCollectionsList: {
          ...state.taxCollectionsList,
          loading: false,
          error,
        },
      };

    case "GET_TAX_COLLECTION":
      return {
        ...state,
        taxCollection: {
          ...state.taxCollection,
          loading: true,
          error: null,
          data: null,
        },
      };

    case "GET_TAX_COLLECTION_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        taxCollection: {
          ...state.taxCollection,
          data: { ...data.data },
          loading: false,
          error: null,
        },
      };

    case "GET_TAX_COLLECTION_FAIL":
      return {
        ...state,
        loggedIn: false,
        taxCollection: {
          ...state.taxCollection,
          loading: false,
          error,
        },
      };

    case "CREATE_PH10":
      return {
        ...state,
        PH10s: {
          ...state.PH10s,
          loading: true,
          error: null,
          data: null,
        },
      };

    case "CREATE_PH10_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        PH10s: {
          ...state.PH10s,
          data: data.data,
          loading: false,
          error: null,
        },
      };

    case "CREATE_PH10_FAIL":
      return {
        ...state,
        loggedIn: false,
        PH10s: {
          ...state.PH10s,
          loading: false,
          error,
        },
      };

    case "GET_YEARLY_TOTAL_AND_PAID_TAX":
      return {
        ...state,
        yearlyTotalAndPaidTax: {
          ...state.yearlyTotalAndPaidTax,
          loading: true,
          data: null,
          error: null,
        },
      };

    case "GET_YEARLY_TOTAL_AND_PAID_TAX_SUCCESS":
      return {
        ...state,
        yearlyTotalAndPaidTax: {
          ...state.yearlyTotalAndPaidTax,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_YEARLY_TOTAL_AND_PAID_TAX_FAIL":
      return {
        ...state,
        yearlyTotalAndPaidTax: {
          ...state.yearlyTotalAndPaidTax,
          loading: false,
          error,
        },
      };
    case "GET_YEARLY_PAID_AND_PENDING_UNITS":
      return {
        ...state,
        yearlyPaidAndPendingUnits: {
          ...state.yearlyPaidAndPendingUnits,
          loading: true,
        },
      };
    case "GET_YEARLY_PAID_AND_PENDING_UNITS_SUCCESS":
      return {
        ...state,
        yearlyPaidAndPendingUnits: {
          ...state.yearlyPaidAndPendingUnits,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_YEARLY_PAID_AND_PENDING_UNITS_FAIL":
      return {
        ...state,
        yearlyPaidAndPendingUnits: {
          ...state.yearlyPaidAndPendingUnits,
          loading: false,
          error,
        },
      };
    case "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_ZONE":
      return {
        ...state,
        yearlyTotalAndPaidTaxOfZone: {
          ...state.yearlyTotalAndPaidTaxOfZone,
          loading: true,
        },
      };

    case "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_ZONE_SUCCESS":
      return {
        ...state,
        yearlyTotalAndPaidTaxOfZone: {
          ...state.yearlyTotalAndPaidTaxOfZone,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_ZONE_FAIL":
      return {
        ...state,
        yearlyTotalAndPaidTaxOfZone: {
          ...state.yearlyTotalAndPaidTaxOfZone,
          loading: false,
          error,
        },
      };
    case "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_CIRCLE":
      return {
        ...state,
        yearlyTotalAndPaidTaxOfCircle: {
          ...state.yearlyTotalAndPaidTaxOfCircle,
          loading: true,
        },
      };

    case "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_CIRCLE_SUCCESS":
      return {
        ...state,
        yearlyTotalAndPaidTaxOfCircle: {
          ...state.yearlyTotalAndPaidTaxOfCircle,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_CIRCLE_FAIL":
      return {
        ...state,
        yearlyTotalAndPaidTaxOfCircle: {
          ...state.yearlyTotalAndPaidTaxOfCircle,
          loading: false,
          error,
        },
      };
    case "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_ZONE":
      return {
        ...state,
        yearlyPaidAndPendingUnitsOfZone: {
          ...state.yearlyPaidAndPendingUnitsOfZone,
          loading: true,
        },
      };
    case "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_ZONE_SUCCESS":
      return {
        ...state,
        yearlyPaidAndPendingUnitsOfZone: {
          ...state.yearlyPaidAndPendingUnitsOfZone,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_ZONE_FAIL":
      return {
        ...state,
        yearlyPaidAndPendingUnitsOfZone: {
          ...state.yearlyPaidAndPendingUnitsOfZone,
          loading: false,
          error,
        },
      };
    case "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_CIRCLE":
      return {
        ...state,
        yearlyPaidAndPendingUnitsOfCircle: {
          ...state.yearlyPaidAndPendingUnitsOfCircle,
          loading: true,
        },
      };
    case "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_CIRCLE_SUCCESS":
      return {
        ...state,
        yearlyPaidAndPendingUnitsOfCircle: {
          ...state.yearlyPaidAndPendingUnitsOfCircle,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_CIRCLE_FAIL":
      return {
        ...state,
        yearlyPaidAndPendingUnitsOfCircle: {
          ...state.yearlyPaidAndPendingUnitsOfCircle,
          loading: false,
          error,
        },
      };
    case "GET_TOTAL_REGISTERED_PROPERTIES_OF_ZONE":
      return {
        ...state,
        totalRegisteredPropertiesOfZone: {
          ...state.totalRegisteredPropertiesOfZone,
          loading: true,
        },
      };
    case "GET_TOTAL_REGISTERED_PROPERTIES_OF_ZONE_SUCCESS":
      return {
        ...state,
        totalRegisteredPropertiesOfZone: {
          ...state.totalRegisteredPropertiesOfZone,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_TOTAL_REGISTERED_PROPERTIES_OF_ZONE_FAIL":
      return {
        ...state,
        totalRegisteredPropertiesOfZone: {
          ...state.totalRegisteredPropertiesOfZone,
          loading: false,
          error,
        },
      };
    case "GET_TAX_OF_ZONE":
      return {
        ...state,
        taxOfZone: {
          ...state.taxOfZone,
          loading: true,
        },
      };
    case "GET_TAX_OF_ZONE_SUCCESS":
      return {
        ...state,
        taxOfZone: {
          ...state.taxOfZone,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_TAX_OF_ZONE_FAIL":
      return {
        ...state,
        taxOfZone: {
          ...state.taxOfZone,
          loading: false,
          error,
        },
      };
    case "GET_TOP_PAID_UNITS_OF_ZONE":
      return {
        ...state,
        topPaidUnitsOfZone: {
          ...state.topPaidUnitsOfZone,
          loading: true,
        },
      };
    case "GET_TOP_PAID_UNITS_OF_ZONE_SUCCESS":
      return {
        ...state,
        topPaidUnitsOfZone: {
          ...state.topPaidUnitsOfZone,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_TOP_PAID_UNITS_OF_ZONE_FAIL":
      return {
        ...state,
        topPaidUnitsOfZone: {
          ...state.topPaidUnitsOfZone,
          loading: false,
          error,
        },
      };
    case "GET_TOP_DEFAULT_UNITS_OF_ZONE":
      return {
        ...state,
        topDefaultUnitsOfZone: {
          ...state.topDefaultUnitsOfZone,
          loading: true,
        },
      };
    case "GET_TOP_DEFAULT_UNITS_OF_ZONE_SUCCESS":
      return {
        ...state,
        topDefaultUnitsOfZone: {
          ...state.topDefaultUnitsOfZone,
          data: data,
          loading: false,
          error: null,
        },
      };
    case "GET_TOP_DEFAULT_UNITS_OF_ZONE_FAIL":
      return {
        ...state,
        topDefaultUnitsOfZone: {
          ...state.topDefaultUnitsOfZone,
          loading: false,
          error,
        },
      };
    case "GET_TOTAL_REGISTERED_PROPERTIES_OF_CIRCLE":
      return {
        ...state,
        totalRegisteredPropertiesOfCircle: {
          ...state.totalRegisteredPropertiesOfCircle,
          loading: true,
        },
      };
    case "GET_TOTAL_REGISTERED_PROPERTIES_OF_CIRCLE_SUCCESS":
      return {
        ...state,
        totalRegisteredPropertiesOfCircle: {
          ...state.totalRegisteredPropertiesOfCircle,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_TOTAL_REGISTERED_PROPERTIES_OF_CIRCLE_FAIL":
      return {
        ...state,
        totalRegisteredPropertiesOfCircle: {
          ...state.totalRegisteredPropertiesOfCircle,
          loading: false,
          error,
        },
      };
    case "GET_TAX_OF_CIRCLE":
      return {
        ...state,
        taxOfCircle: {
          ...state.taxOfCircle,
          loading: true,
        },
      };
    case "GET_TAX_OF_CIRCLE_SUCCESS":
      return {
        ...state,
        taxOfCircle: {
          ...state.taxOfCircle,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_TAX_OF_CIRCLE_FAIL":
      return {
        ...state,
        taxOfCircle: {
          ...state.taxOfCircle,
          loading: false,
          error,
        },
      };
    case "GET_TOP_PAID_UNITS_OF_CIRCLE":
      return {
        ...state,
        topPaidUnitsOfCircle: {
          ...state.topPaidUnitsOfCircle,
          loading: true,
        },
      };
    case "GET_TOP_PAID_UNITS_OF_CIRCLE_SUCCESS":
      return {
        ...state,
        topPaidUnitsOfCircle: {
          ...state.topPaidUnitsOfCircle,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_TOP_PAID_UNITS_OF_CIRCLE_FAIL":
      return {
        ...state,
        topPaidUnitsOfCircle: {
          ...state.topPaidUnitsOfCircle,
          loading: false,
          error,
        },
      };
    case "GET_TOP_DEFAULT_UNITS_OF_CIRCLE":
      return {
        ...state,
        topDefaultUnitsOfCircle: {
          ...state.topDefaultUnitsOfCircle,
          loading: true,
        },
      };
    case "GET_TOP_DEFAULT_UNITS_OF_CIRCLE_SUCCESS":
      return {
        ...state,
        topDefaultUnitsOfCircle: {
          ...state.topDefaultUnitsOfCircle,
          data: data,
          loading: false,
          error: null,
        },
      };
    case "GET_TOP_DEFAULT_UNITS_OF_CIRCLE_FAIL":
      return {
        ...state,
        topDefaultUnitsOfCircle: {
          ...state.topDefaultUnitsOfCircle,
          loading: false,
          error,
        },
      };

    case "GET_YEARLY_PAID_TAX_TI":
      return {
        ...state,
        yearlyPaidTaxTi: {
          ...state.yearlyPaidTaxTi,
          loading: true,
        },
      };
    case "GET_YEARLY_PAID_TAX_TI_SUCCESS":
      return {
        ...state,
        yearlyPaidTaxTi: {
          ...state.yearlyPaidTaxTi,
          loading: false,
          data,
        },
      };
    case "GET_YEARLY_PAID_TAX_TI_FAIL":
      return {
        ...state,
        yearlyPaidTaxTi: {
          ...state.yearlyPaidTaxTi,
          loading: false,
          error,
        },
      };

    case "GET_TI_TOTAL_PENDING_TAX":
      return {
        ...state,
        totalPendingTaxTi: {
          ...state.totalPendingTaxTi,
          loading: true,
        },
      };
    case "GET_TI_TOTAL_PENDING_TAX_SUCCESS":
      return {
        ...state,
        totalPendingTaxTi: {
          ...state.totalPendingTaxTi,
          loading: false,
          data,
        },
      };
    case "GET_TI_TOTAL_PENDING_TAX_FAIL":
      return {
        ...state,
        totalPendingTaxTi: {
          ...state.totalPendingTaxTi,
          loading: false,
          error,
        },
      };
    case "GET_CIRCLE_OR_ZONE_NAME":
      return {
        ...state,
        circleOrZoneName: {
          ...state.circleOrZoneName,
          loading: true,
        },
      };
    case "GET_CIRCLE_OR_ZONE_NAME_SUCCESS":
      return {
        ...state,
        circleOrZoneName: {
          ...state.circleOrZoneName,
          loading: false,
          data,
        },
      };
    case "GET_CIRCLE_OR_ZONE_NAME_FAIL":
      return {
        ...state,
        circleOrZoneName: {
          ...state.circleOrZoneName,
          loading: false,
          error,
        },
      };
    case "GET_TAX_DETAILS_PROPERTY_BASED_ON_YEAR":
      return {
        ...state,
        taxDetailsOfPropertyBasedOnYear: {
          ...state.taxDetailsOfPropertyBasedOnYear,
          loading: true,
        },
      };
    case "GET_TAX_DETAILS_PROPERTY_BASED_ON_YEAR_SUCCESS":
      return {
        ...state,
        taxDetailsOfPropertyBasedOnYear: {
          ...state.taxDetailsOfPropertyBasedOnYear,
          loading: false,
          data,
        },
      };
    case "GET_TAX_DETAILS_PROPERTY_BASED_ON_YEAR_FAIL":
      return {
        ...state,
        taxDetailsOfPropertyBasedOnYear: {
          ...state.taxDetailsOfPropertyBasedOnYear,
          loading: false,
          error,
        },
      };
    case "GENERATE_CHALLAN":
      return {
        ...state,
        generateChallan: {
          ...state.generateChallan,
          loading: true,
        },
      };
    case "GENERATE_CHALLAN_SUCCESS":
      return {
        ...state,
        generateChallan: {
          ...state.generateChallan,
          loading: false,
          data,
        },
      };
    case "GENERATE_CHALLAN_FAIL":
      return {
        ...state,
        generateChallan: {
          ...state.generateChallan,
          loading: false,
          error,
        },
      };
    case "GET_TAX_PROPERTIES":
      return {
        ...state,
        type,
        error: null,
        taxPropertiesList: {
          ...initialState.taxPropertiesList,
          loading: true,
        },
      };

    case "GET_TAX_PROPERTIES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        taxPropertiesList: {
          ...state.taxPropertiesList,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_TAX_PROPERTIES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        taxPropertiesList: {
          ...state.taxPropertiesList,
          loading: false,
          error,
        },
      };
    default:
      return state;
  }
};

export default propertyReducer;
